import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./services/authService";

const queryClient = new QueryClient();

/**
 * MSAL Initialization
 *
 * IMPORTANT: For popup auth to work correctly:
 * 1. The redirect URI in msalConfig must match what's registered in Azure AD
 * 2. Azure AD must have the admin panel URL registered, not the main app URL
 */
msalInstance.initialize().then(() => {
  // Handle redirect promise for any auth redirects
  msalInstance.handleRedirectPromise().then((response) => {
    if (response) {
      console.log("Auth redirect handled:", response.account?.username);
    }
  }).catch((error) => {
    console.error("Error handling redirect:", error);
  });

  // Only render the app - MSAL handles popup internally
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </MsalProvider>
    </React.StrictMode>
  );
}).catch(console.error);
